// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"e4165103","41":"c7ec3201","88":"b1110b41","134":"ca6aba30","240":"d65e0b96","357":"1d4d2d7d","364":"2a7acfc1","651":"c0a26dd2","690":"9452648c","754":"6947dcf3","815":"6dcff1be","955":"647dbf5d"}[chunkId] + ".chunk.js";
};